import React from 'react';
import { Button, Typography, Row, Col } from 'antd';
import { TeamOutlined, UserAddOutlined, UserOutlined, UsergroupAddOutlined } from '@ant-design/icons';

import { ClaimOptionCard } from './ClaimOptionCard';

const { Text, Title, Paragraph } = Typography;

/**
 * Renders the claim options (choose step) using ClaimOptionCard.
 * Receives copy from useClaimCopy and callbacks from parent.
 */
export function ClaimOptionsChooser({
  copy,
  isTeamsAllowed,
  hasTeams,
  isTeamOnly,
  onlyOneOption,
  onlyOptionIsCreateTeam,
  optionCount,
  onSelectIndividual,
  onSelectTeam,
  onSelectCreateTeam,
  onGoToDashboard,
}) {
  if (!copy) return null;

  const { individual, existingTeam, createTeam } = copy;

  const { choose, buttons } = copy;

  return (
    <>
      <Title level={3} style={{ marginTop: 24 }}>
        {choose.title}
      </Title>
      <Paragraph type="secondary">{choose.subtitle}</Paragraph>

      <div style={{ marginTop: 24 }}>
        {onlyOneOption ? (
          <>
            {onlyOptionIsCreateTeam && (
              <ClaimOptionCard
                icon={<UserAddOutlined />}
                title={createTeam.title}
                description={createTeam.description}
                variant="primary"
                onClick={onSelectCreateTeam}
              />
            )}
            {!isTeamsAllowed && !isTeamOnly && (
              <ClaimOptionCard
                icon={<UserOutlined />}
                title={individual.title}
                description={individual.subtitle}
                variant="primary"
                onClick={onSelectIndividual}
              />
            )}
          </>
        ) : (
          <>
            {isTeamsAllowed && hasTeams && (
              <div style={{ marginBottom: 16 }}>
                <ClaimOptionCard
                  icon={<TeamOutlined />}
                  title={existingTeam.title}
                  description={existingTeam.description}
                  variant="primary"
                  onClick={onSelectTeam}
                />
              </div>
            )}
            <Row gutter={[16, 16]}>
              {isTeamsAllowed && (
                <Col xs={24} md={optionCount === 2 ? 24 : 12}>
                  <ClaimOptionCard
                    icon={<UsergroupAddOutlined />}
                    title={createTeam.title}
                    description={createTeam.description}
                    variant={hasTeams ? 'secondary' : 'primary'}
                    onClick={onSelectCreateTeam}
                  />
                </Col>
              )}
              {!isTeamOnly && (
                <Col xs={24} md={optionCount === 2 ? 24 : 12}>
                  <ClaimOptionCard
                    icon={<UserOutlined />}
                    title={individual.title}
                    description={individual.subtitle}
                    variant={hasTeams ? 'reduced' : 'secondary'}
                    onClick={onSelectIndividual}
                  />
                </Col>
              )}
            </Row>
          </>
        )}
        <div
          style={{
            marginTop: 24,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 4,
          }}
        >
          <Button
            type="default"
            onClick={onGoToDashboard}
            style={{
              width: '50%',
              minWidth: 'fit-content',
              borderRadius: 8,
              borderColor: '#d9d9d9',
              color: '#595959',
            }}
          >
            {buttons.continueWithoutSetup}
          </Button>
          <Text type="secondary" style={{ fontSize: 12, textAlign: 'center' }}>
            {choose.skipAssignText}
          </Text>
        </div>
      </div>
    </>
  );
}
